<div class="flex flex-col self-stretch gap-2.5"
     [attr.data-test]="'template-display'"
     [formGroup]="templateForm"
>
  <div class="flex justify-between items-center">
    <h1 class="template-headline"
        [attr.data-test]="'template-headline'"
    > Template ({{ manager.isReadOnly() ? 'View' : (manager.isEditMode() ? 'Edit' : 'Create') }} Mode)</h1>

    <div class="flex justify-between items-center gap-2.5">
      @if (manager.isViewMode()) {
        <button pButton
                type="button"
                severity="primary"
                [attr.data-test]="'template-edit-button'"
                [disabled]="!permissionService.hasRedactRights()"
                (click)="onEdit()"
        >
          Edit
        </button>
        <button pButton
                type="button"
                severity="secondary"
                [attr.data-test]="'template-duplicate-button'"
                [disabled]="!permissionService.hasRedactRights()"
                (click)="onDuplicate()"
        >
          Duplicate
        </button>
      } @else {
        <button pButton
                type="button"
                severity="primary"
                [attr.data-test]="'template-confirm-button'"
                [disabled]="templateForm.invalid"
                (click)="onSave()"
        >
          Confirm
        </button>
        @if (manager.isEditMode()) {
          <button pButton
                  type="button"
                  severity="secondary"
                  [attr.data-test]="'template-delete-button'"
                  [outlined]="true"
                  (click)="onDelete()"
          >
            Delete
          </button>
        }
        <button pButton
                type="button"
                severity="secondary"
                [attr.data-test]="'template-cancel-button'"
                [outlined]="true"
                (click)="onCancel()"
        >
          Cancel
        </button>
      }
      @if (manager.isViewMode()) {
        <button pButton
                type="button"
                severity="secondary"
                [attr.data-test]="'template-close-button'"
                (click)="onClose()"
        >
          Close
        </button>
      }
    </div>
  </div>

  @let titleControl = templateForm.get('title');
  <div>
    <p-iftalabel class="w-full">
      <input class="w-full p-inputtext"
             formControlName="title"
             id="title"
             pInputText
             placeholder="Enter Template title"
             type="text"
             [attr.data-test]="'template-title'"
             [invalid]="titleControl?.invalid && titleControl?.touched"
             [required]="true"
      />
      <label for="title">Title *</label>
    </p-iftalabel>
    @if (titleControl?.errors?.['required'] && titleControl?.touched) {
      <small class="block text-red-500 text-xs mt-1">Title is required.</small>
    }
    @if (titleControl?.errors?.['templateExists'] && titleControl?.touched) {
      <small class="block text-red-500 text-xs mt-1">Title exists already, please choose a different name.</small>
    }
  </div>

  <div>
    <p-iftalabel class="w-full">
      <textarea class="w-full"
                formControlName="description"
                id="description"
                pTextarea
                placeholder="Enter Template description"
                rows="3"
                [attr.data-test]="'template-description'"
                [autoResize]="false"
      ></textarea>
      <label for="description">Description</label>
    </p-iftalabel>
  </div>

  <div>
    <p-iftalabel>
      <p-autocomplete fluid
                      formControlName="tags"
                      inputId="tags"
                      multiple
                      separator=","
                      [addOnBlur]="true"
                      [addOnTab]="true"
                      [attr.data-test]="'template-tags'"
                      [minQueryLength]="3"
                      [suggestions]="manager.suggestedTags()"
                      (completeMethod)="onTagsSearch($event)"
      />
      <label for="tags">Tags</label>
    </p-iftalabel>
  </div>

  <div class="flex gap-4">
    <div class="flex-1">
      @let certControl = templateForm.get('certificateCategory');
      <p-iftalabel>
        <p-select class="w-full"
                  formControlName="certificateCategory"
                  id="certificateCategory"
                  optionLabel="label"
                  optionValue="value"
                  [attr.data-test]="'template-certificate-category'"
                  [invalid]="conditionFormElementValidity(certControl)"
                  [options]="certificateCategoryOptions"
                  [required]="true"
        />
        <label for="certificateCategory">Certificate Category *</label>
      </p-iftalabel>
    </div>
    <div class="flex-1">
      @let coverageControl = templateForm.get('coverageType');
      <p-iftalabel>
        <p-select class="w-full"
                  formControlName="coverageType"
                  id="coverageType"
                  optionLabel="label"
                  optionValue="value"
                  [attr.data-test]="'template-coverage-type'"
                  [invalid]="conditionFormElementValidity(coverageControl)"
                  [options]="coverageTypeOptions"
                  [required]="true"
        />
        <label for="coverageType">Coverage Type *</label>
      </p-iftalabel>
    </div>
  </div>
  @if (shouldShowConditionError) {
    <small class="block text-red-500 text-xs -mt-2">This combination of Category and Coverage already exists.</small>
  }

  <div class="flex items-center gap-2">
    <p-toggleswitch formControlName="showDetails"
                    id="showDetails"
                    [attr.data-test]="'template-show-details'"
    />
    <label for="showDetails">Details</label>
  </div>

  <p-divider align="left"
             type="solid"
  >Content Units
  </p-divider>
  <div>
    <albert-template-cu-list
      [attr.data-test]="'template-cu-list'"
      [formArray]="templateForm.controls.contentUnits"
      [showDetails]="showDetails() ?? false"
      [viewMode]="manager.isViewMode()"
    />
  </div>
</div>
